import type * as CSS from 'csstype';

import colors from './colors';
import type { Product } from '../types/product';

export interface ShadowsVariants {
  /** @returns `none` */
  0: CSS.Property.BoxShadow;
  /** @returns `10px 10px 0 0 rgba(0, 0, 0, 0.3)` */
  10: CSS.Property.BoxShadow;
  /** @returns `15px 15px 0 0 rgba(0, 0, 0, 0.3)` */
  15: CSS.Property.BoxShadow;
  /** @returns `20px 20px 0 0 rgba(0, 0, 0, 0.3)` */
  20: CSS.Property.BoxShadow;
  /** @returns `4px 4px 0 ${colors.coolGrey[20]}` */
  cardList: CSS.Property.BoxShadow;
  /** @returns `2px 2px 4px ${colors.coolGrey[20]}` */
  cardTextOnly: CSS.Property.BoxShadow;
  /** @returns `0 0 10px rgba(0, 0, 0, 0.3)` */
  image: CSS.Property.BoxShadow;
  /** @returns `0 0 5px 0 rgba(0, 0, 0, 0.1)` */
  listItem: CSS.Property.BoxShadow;
  /** @returns `2px 2px 2px rgba(196, 196, 196, 0.5)` */
  nav: CSS.Property.BoxShadow;
  /** @returns `0px -4px 8px rgba(40, 44, 51, 0.15)` */
  video: CSS.Property.BoxShadow;
}

export type Shadows = ShadowsVariants &
  Product.VariantModes<{
    [K in ShadowsVariantsType]: CSS.Property.BoxShadow;
  }>;

const base: ShadowsVariants = {
  0: 'none',
  10: '10px 10px 0 0 rgba(0, 0, 0, 0.3)',
  15: '15px 15px 0 0 rgba(0, 0, 0, 0.3)',
  20: '20px 20px 0 0 rgba(0, 0, 0, 0.3)',
  cardList: `4px 4px 0 ${colors.coolGrey[20]}`,
  cardTextOnly: `2px 2px 4px ${colors.coolGrey[20]}`,
  image: '0 0 10px rgba(0, 0, 0, 0.3)',
  listItem: '0 0 5px 0 rgba(0, 0, 0, 0.1)',
  nav: '2px 2px 8px rgba(40, 44, 51, 0.2)',
  video: '0px -4px 8px rgba(40, 44, 51, 0.15)',
};

const shadows: Shadows = {
  ...base,
  products: {
    chart: base,
    chartblog: base,
    co: base,
    edu: base,
    scale: base,
    spark: base,
  },
};

export type ShadowsVariantsType = '0' | '10' | '15' | '20' | 'cardList' | 'cardTextOnly' | 'listItem' | 'video';
export const shadowsVariants = Object.keys(base) as ShadowsVariantsType[];

export default shadows;
